angular.module('unica_campaign_attachment.campaign_attachment_services')

.factory('CampaignAttachmentListService', function ($http, getBaseApiURL) {

	var campaignAttachmentService = {};

	campaignAttachmentService.list = function (campaignTemplateId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign-attachment/list/' + campaignTemplateId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign_attachments;
			}

		});

	};

	return campaignAttachmentService;
});